<template>
  <span class="tw-tabular-nums">
    <template v-if="pendingExtension">
      {{ start }} -
      <del class="tw-text-gray-500" data-test="hire-date-range-old-end">{{ formatDate(pendingExtension.previousEndDate) }}</del>
      <span class="tw-ml-2 tw-font-medium tw-text-orange-600" data-test="hire-date-range-extended">{{ formatDate(pendingExtension.newEndDate) }}</span>
    </template>
    <template v-else>{{ start }} - {{ end }}</template>
  </span>
</template>

<script lang="ts" setup>
import useDate from '@/composables/useDate'

defineProps<{
  start: string | null
  end: string | null
  pendingExtension?: { previousEndDate: string; newEndDate: string } | null
}>()

const formatDate = (date: string) => useDate(date).date.value
</script>
